import Uid from './Uid';
import RoundNum from './RoundNum';

const globals = {
  qlik: null,
  resize: null,
};

export default { Uid, RoundNum, globals };
